var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2438 7.88489H6.5956C6.16319 7.88489 5.83252 8.23088 5.83252 8.68333C5.83252 9.13578 6.16319 9.48177 6.5956 9.48177H15.2438C15.6762 9.48177 16.0069 9.13578 16.0069 8.68333C16.0069 8.23088 15.6762 7.88489 15.2438 7.88489Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2438 11.7218H6.5956C6.16319 11.7218 5.83252 12.0678 5.83252 12.5202C5.83252 12.9727 6.16319 13.3187 6.5956 13.3187H15.2438C15.6762 13.3187 16.0069 12.9727 16.0069 12.5202C16.0069 12.0678 15.6762 11.7218 15.2438 11.7218Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.421 0.588013H9.41958C4.23066 0.588013 0.00830078 5.00604 0.00830078 10.4354V21.3474C0.00830078 21.9862 0.338967 22.2523 0.542455 22.3322C0.669634 22.3854 0.771378 22.412 0.898557 22.412C1.33097 22.412 1.68707 22.066 2.11948 21.6402C2.67907 21.1079 3.54389 20.2828 4.3324 20.2828H12.421C17.6099 20.2828 21.8323 15.8648 21.8323 10.4354C21.8323 5.00604 17.6099 0.588013 12.421 0.588013ZM12.421 18.686H4.3324C3.21322 18.686 2.24666 19.4046 1.53445 20.0699V10.4354C1.53445 5.88433 5.07004 2.18489 9.41958 2.18489H12.421C16.7706 2.18489 20.3061 5.88433 20.3061 10.4354C20.3061 14.9865 16.7706 18.686 12.421 18.686Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComentIcon);
export default __webpack_public_path__ + "static/media/comentIcon.b71c97375078add1a8c20c9c0254f493.svg";
export { ForwardRef as ReactComponent };